/* eslint-disable import/prefer-default-export */
export const light = {
  title: 'light',

  colors: {
    primary: '#DCDCDC',
    secondary: '#FFF',
    tertiary: '#F5F5F5',

    white: '#000',
    black: '#fff',
    gray: '#BFBFBF',

    success: '#03BB85',
    info: '#3B5998',
    warning: '#FF6961'
  }
};
